const visitedTabKey = "MATRIXTECH_VISITED_TABS";
const activeTabKey = "MATRIXTECH_ACTIVE_TAB";
const MenusKey = "saas-menus";

// ---- 菜单就绪 Promise ----
// 用于消除“读菜单(getMenus)”与“拉菜单接口”之间的时序竞争，
// 替代原先在 loadRoutesFromBackend 里写死的 setTimeout(500) 盲等。
let _menusResolve: ((value: any) => void) | null = null;
// 是否有一次“进行中”的菜单刷新（登录 / 切换租户 / 切换角色）。
// 为 true 时，等待方应等 setMenus 写入最新菜单，而不是直接读旧缓存。
let _menusPendingFresh = false;
let _menusPromise = createMenusPromise();

function createMenusPromise() {
  return new Promise((resolve) => {
    _menusResolve = resolve;
  });
}

/**
 * 等待菜单就绪：
 * - 已有缓存且没有挂起的刷新（F5 刷新场景）-> 立即返回
 * - 有挂起的刷新（登录/切换租户）-> 等待 setMenus 写入新菜单，超时兜底
 * - 既无缓存也无挂起刷新（首次进入登录页）-> 立即返回，不阻塞应用启动
 */
export const waitMenusReady = (timeout = 5000) => {
  const cached = localStorage.getItem(MenusKey);
  if (!_menusPendingFresh) {
    return Promise.resolve(!!cached);
  }
  return Promise.race([
    _menusPromise,
    new Promise((resolve) => setTimeout(() => resolve(false), timeout)),
  ]);
};

/**
 * 标记“即将刷新菜单”，等待方不应直接读旧缓存，需等待 setMenus。
 * 注意：不清空 localStorage 中的旧菜单，避免路由守卫误判为未登录跳登录页。
 */
export const resetMenusReady = () => {
  _menusPendingFresh = true;
  _menusPromise = createMenusPromise();
};

// 缓存菜单
export const getMenus = () => {
  try {
    return localStorage.getItem(MenusKey);
  } catch (error) {
    console.error("Failed to get token:", error);
    return null;
  }
};

export const setMenus = (data) => {
  try {
    localStorage.setItem(MenusKey, data);
  } catch (error) {
    console.error("Failed to set token:", error);
  }
  // 通知等待方：菜单已写入，取消“挂起刷新”标记
  _menusPendingFresh = false;
  if (_menusResolve) {
    const resolve = _menusResolve;
    _menusResolve = null;
    resolve(data);
  }
};

// 清除菜单缓存
export const clearMenus = () => {
  try {
    localStorage.removeItem(MenusKey);
  } catch (error) {
    console.error("Failed to clear menus:", error);
  }
};



// 缓存访问过的标签页
export const getVisitedTabs = () => {
  try {
    const tabs = localStorage.getItem(visitedTabKey);
    return tabs ? JSON.parse(tabs) : tabs;
  } catch (error) {
    console.error("Failed to get token:", error);
    return null;
  }
};

export const setVisitedTabs = (data) => {
  try {
    const tabs = JSON.stringify(data);
    localStorage.setItem(visitedTabKey, tabs);
  } catch (error) {
    console.error("Failed to set token:", error);
  }
};

// 缓存当前激活的标签页
export const getActiveTab = () => {
  try {
    return localStorage.getItem(activeTabKey)
  } catch (error) {
    console.error("Failed to get token:", error);
    return null;
  }
};

export const setActiveTab = (data) => {
  try {
    localStorage.setItem(activeTabKey, data);
  } catch (error) {
    console.error("Failed to set token:", error);
  }
};

